"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFromXmlToJson = void 0;
const fast_xml_parser_1 = require("fast-xml-parser");
const convertFromXmlToJson = (xml, options) => {
    const parser = new fast_xml_parser_1.XMLParser({ ignoreAttributes: false, ...options });
    const json = parser.parse(xml);
    return json;
};
exports.convertFromXmlToJson = convertFromXmlToJson;
//# sourceMappingURL=convertFromXmlToJson.js.map